'use client';

interface Props {
  containerId: string;
  blockClassName: string;
}

export const useSlide = ({ blockClassName, containerId }: Props) => {
  const smoothScroll = (container: HTMLElement, distance: number, duration: number) => {
    const start = container.scrollLeft;
    const startTime = performance.now();

    const scrollStep = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      container.scrollLeft = start + distance * progress;

      if (progress < 1) {
        requestAnimationFrame(scrollStep);
      }
    };

    requestAnimationFrame(scrollStep);
  };

  const onSlideRight = () => {
    const container = document.getElementById(containerId) as HTMLElement;
    const block = document.querySelector(`.${blockClassName}`) as HTMLElement;

    if (block && container) {
      const blockWidth = block.offsetWidth;
      smoothScroll(container, blockWidth, 290);
    }
  };

  const onSlideLeft = () => {
    const container = document.getElementById(containerId) as HTMLElement;
    const block = document.querySelector(`.${blockClassName}`) as HTMLElement;

    if (block && container) {
      const blockWidth = block.offsetWidth;
      smoothScroll(container, -blockWidth, 290);
    }
  };

  return { onSlideRight, onSlideLeft };
};
